import { getAxiosFulfilledState, getPendingState, getRejectedState, resetState } from '../helpers/reducerHelper'
import { IReduxAction } from './index'
import { DataPromise, getDataEmptyState } from '../context/AxiosContext'
import { Country, Currency, I18nAction, Language } from '../config/i18nConfig'
import { ActionType } from 'redux-promise-middleware'

type State = {
    countries: DataPromise<Country[]>
    currencies: DataPromise<Currency[]>
    languages: DataPromise<Language[]>
}

const defaultState: State = {
    countries: getDataEmptyState<Country[]>(),
    currencies: getDataEmptyState<Currency[]>(),
    languages: getDataEmptyState<Language[]>(),
}

export default function reducer(state: State = defaultState, action: IReduxAction): State {
    switch (action.type) {
        case `${I18nAction.GetCountries}_${ActionType.Pending}`: {
            return getPendingState(state, 'countries')
        }
        case `${I18nAction.GetCountries}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'countries')
        }
        case `${I18nAction.GetCountries}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'countries')
        }
        case `${I18nAction.GetCurrencies}_${ActionType.Pending}`: {
            return getPendingState(state, 'currencies')
        }
        case `${I18nAction.GetCurrencies}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'currencies')
        }
        case `${I18nAction.GetCurrencies}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'currencies')
        }
        case `${I18nAction.GetLanguages}_${ActionType.Pending}`: {
            return getPendingState(state, 'languages')
        }
        case `${I18nAction.GetLanguages}_${ActionType.Rejected}`: {
            return getRejectedState(state, action, 'languages')
        }
        case `${I18nAction.GetLanguages}_${ActionType.Fulfilled}`: {
            return getAxiosFulfilledState(state, action, 'languages')
        }
        case I18nAction.ResetCountries: {
            return resetState(state, { countries: [] })
        }
        case I18nAction.ResetCurrencies: {
            return resetState(state, { currencies: [] })
        }
        case I18nAction.ResetLanguages: {
            return resetState(state, { languages: [] })
        }
    }

    return state
}
